(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-arrivals-carousel"] && !Shopify.designMode) return;
  try {
    
/* === UN ATELIER — New Arrivals • circular, no-jump binder (section-scoped) === */
(function () {
  function setup(root) {
    if (!root || root.dataset.circular === '1') return;
    root.dataset.circular = '1';

    const track = root.querySelector('.na-track');
    const prev  = root.querySelector('.na-prev');
    const next  = root.querySelector('.na-next');
    if (!track) return;

    // keep track pure
    Array.from(track.children).forEach(n => { if (!n.classList?.contains('na-card')) n.remove(); });
    new MutationObserver(m => m.forEach(x => x.addedNodes.forEach(n => {
      if (n.nodeType === 1 && !n.classList?.contains('na-card')) n.remove();
    }))).observe(track, { childList:true });

    // show arrows
    [prev, next].forEach(btn => { if (btn){ btn.removeAttribute('hidden'); btn.removeAttribute('disabled'); btn.setAttribute('aria-disabled','false'); } });

    const originals = Array.from(track.querySelectorAll('.na-card'));
    const N = originals.length; if (!N) return;

    // clone once on each side
    const L = document.createDocumentFragment(), R = document.createDocumentFragment();
    originals.forEach(n => L.appendChild(n.cloneNode(true)));
    originals.forEach(n => R.appendChild(n.cloneNode(true)));
    track.insertBefore(L, track.firstChild); track.appendChild(R);

    // measurements
    let stepW = 0;
    const perView = () => (window.innerWidth >= 1000 ? 4 : 2);
    const cssGap = () => { const s = getComputedStyle(track); const g = parseFloat(s.gap || s.columnGap || '18'); return isNaN(g) ? 18 : g; };
    function measure(){
      const first = track.querySelector('.na-card'); if (!first) return;
      const w = first.getBoundingClientRect().width; if (w === 0) return setTimeout(measure, 50);
      stepW = w + cssGap();
    }

    function centerToOriginalIndex(i){
      const old = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
      track.scrollLeft = stepW * (N + i);
      track.style.scrollBehavior = old || '';
    }

    let userInteracted = false;
    function normalizeIfNeeded(){
      if (!userInteracted || stepW <= 0) return;
      const index = Math.round(track.scrollLeft / stepW);
      const mod   = ((index % N) + N) % N;
      if (index < N || index >= 2*N){
        const old = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
        track.scrollLeft = stepW * (N + mod);
        track.style.scrollBehavior = old || '';
      }
    }

    function go(dir){
      userInteracted = true;
      const pv = perView();
      const currentIdx = Math.round(track.scrollLeft / stepW);
      const targetIdx  = currentIdx + dir * pv;
      track.scrollTo({ left: targetIdx * stepW, behavior: 'smooth' });
      clearTimeout(track._normTimer);
      track._normTimer = setTimeout(normalizeIfNeeded, 220);
    }

    function bind(btn, dir){
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      const h = e => { e.preventDefault(); e.stopPropagation(); go(dir); };
      btn.addEventListener('click', h, { capture:true });
      btn.addEventListener('touchstart', h, { capture:true });
    }
    bind(prev, -1); bind(next, 1);

    new MutationObserver(() => { bind(prev, -1); bind(next, 1); })
      .observe(root, { childList:true, subtree:true });

    ['mousedown','wheel','touchstart','keydown'].forEach(evt => {
      track.addEventListener(evt, () => { userInteracted = true; }, { passive:true });
    });
    track.addEventListener('scroll', () => {
      clearTimeout(track._normTimer);
      track._normTimer = setTimeout(normalizeIfNeeded, 160);
    }, { passive:true });

    function onResize(){
      const currentIndex = Math.round(track.scrollLeft / Math.max(1, stepW)) % N;
      measure();
      if (stepW > 0) centerToOriginalIndex(((currentIndex % N) + N) % N);
    }
    window.addEventListener('resize', onResize);

    function init(){
      measure();
      if (stepW > 0) centerToOriginalIndex(0);
    }
    const imgs = track.querySelectorAll('img');
    let remain = imgs.length;
    if (remain){
      imgs.forEach(img => {
        if (img.complete){ if (--remain === 0) init(); }
        else img.addEventListener('load', () => { if (--remain === 0) init(); }, { once:true });
      });
      setTimeout(init, 1200);
    } else { init(); }
  }

  function initAll(){ document.querySelectorAll('[id^="na-"].na').forEach(setup); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  new MutationObserver(initAll).observe(document.documentElement, { childList:true, subtree:true });
})();

  } catch(e) { console.error(e); }
})();
})();
